import CandidateInfo from 'components/organisms/AppBar/CandidateInfo/CandidateInfo';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PortalLayout.module.scss';

type PortalNavbarProps = {
  companyName: string;
  logoUrl?: string | null;
};

// Whitelabeled top bar shared by the portal page and every portal-journey
// page (e.g. the content stage page): company logo left, candidate menu right.
const PortalNavbar: FC<PortalNavbarProps> = ({ companyName, logoUrl }) => {
  const { t } = useTranslation();

  return (
    <header className={styles.navbar}>
      {logoUrl ? (
        <img
          className={styles.navbarLogo}
          src={logoUrl}
          alt={t('alt.companyLogo', { companyName })}
        />
      ) : (
        <span className={styles.navbarCompanyName}>{companyName}</span>
      )}
      <CandidateInfo />
    </header>
  );
};

export default PortalNavbar;
